{
  "generic": "Ein Fehler ist aufgetreten",
  "networkError": "Netzwerkfehler — bitte überprüfen Sie Ihre Verbindung",
  "unauthorized": "Sie sind nicht berechtigt, diese Aktion durchzuführen",
  "notFound": "Die angeforderte Ressource wurde nicht gefunden",
  "serverError": "Serverfehler — bitte versuchen Sie es später erneut",
  "validationError": "Bitte überprüfen Sie Ihre Eingabe",
  "uploadFailed": "Upload fehlgeschlagen",
  "uploadSuccess_one": "{{count}} Datei erfolgreich hochgeladen",
  "uploadSuccess_other": "{{count}} Dateien erfolgreich hochgeladen",
  "invalidFileType": "Ungültiger Dateityp",
  "fileTooLarge": "Datei ist zu groß",
  "sessionExpired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "loadAgentsFailed": "Agents konnten nicht geladen werden",
  "loadProfileFailed": "Benutzerprofil konnte nicht geladen werden",
  "stream": {
    "hitl_question_undelivered": "Wir konnten die Frage des Assistenten nicht zustellen. Diese Mission ist möglicherweise noch aktiv.",
    "subscription_forbidden": "Sie haben keinen Zugriff auf diese Ausführung.",
    "subscription_unavailable": "Live-Updates für diese Ausführung sind gerade nicht verfügbar. Bitte versuchen Sie es erneut.",
    "control_forbidden": "Sie können diese Ausführung nicht steuern.",
    "control_unavailable": "Diese Ausführung kann gerade nicht gestoppt, angehalten oder fortgesetzt werden. Versuchen Sie es gleich noch einmal.",
    "conversation_not_viewable": "Diese Unterhaltung gehört einer anderen Person. Nur diese Person kann sie hier lesen."
  }
}
